export default __webpack_public_path__ + "images/0x30c8cf6b46aa4df3f9fbc2857aca92f10a6cad7f.png";